import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/allProjectManagersForFieldReportFilter`;

export const ROUTE: RouteDefinition = `${baseRoute}/allProjectManagersForFieldReportFilter`;

export const URL = (): RouteDefinition => `${baseRoute}/allProjectManagersForFieldReportFilter`;
